import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { Observable, tap, timer } from "rxjs";

@Injectable({ providedIn: "root" })
export class BasedPreloadingStrategy extends PreloadingStrategy {
    delayTime: number = 5000;
    preload(route: Route, load: () => Observable<any>): Observable<any> {
        return timer(this.delayTime).pipe(
            tap(() => load())
        )
    }
}